import { CompletionCodeTask } from "./types/Tasks";

export const isCompletionCodeTask = (task: unknown): task is CompletionCodeTask => {
    return typeof (task as CompletionCodeTask)?.config?.completionCode === "string";
} 